import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@bootstrap-styled/v4";
import { useState } from "react";
import { CrazyCalculatorQuestion } from "./CrazyCalculatorQuestion";
import { PreviewCrazyCalculatorQuestionModal } from "./PreviewCrazyCalculatorQuestionModal";

export const EditCrazyCalculatorQuestionModal = ({ challenge, isModalOpen, modalTitle, setIsModalOpen }) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <Modal style={{ maxWidth: "1000px" }} size="lg" isOpen={isModalOpen} toggle={handleClose}>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalBody>
          <CrazyCalculatorQuestion challenge={challenge} showHeader={false}/>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <PreviewCrazyCalculatorQuestionModal challenge={challenge}
                                          isModalOpen={isPreviewModalOpen}
                                          setIsModalOpen={setIsPreviewModalOpen}/>
    </div>
  );
};
